import React, { useState } from 'react';
import { Dimmer, Loader, Button, Dropdown, Modal } from 'semantic-ui-react';
import MenuItemForm from './menuItemForm';

const MenuItem = ({ menuItem, updateHandler, deleteHandler }) => {
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);

    const [deleteMenuItem, setDeleteMenuItem] = useState(false);

    const updateMenu = async (menuItem) => {
        setLoading(true);
        await updateHandler(menuItem);
        setEditMode(false);
        setLoading(false);
    };

    const deleteMenu = async () => {
        setLoading(true);
        await deleteHandler(menuItem._id);
        setDeleteMenuItem(false);
        setLoading(false);
    };

    return (
        <div className="menu-item" key={menuItem._id}>
            <Modal open={deleteMenuItem} onClose={() => setDeleteMenuItem(false)} size="tiny" closeIcon>
                <Modal.Content>
                    <Dimmer active={loading} inverted>
                        <Loader active={loading} />
                    </Dimmer>
                    <p>Are you sure you want to delete Menu Item?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={deleteMenu} color="red">
                        Delete
                    </Button>
                </Modal.Actions>
            </Modal>

            {!editMode ? (
                <>
                    {' '}
                    <div className="content">
                        <div className="menu-type">{menuItem.category}</div>
                        <div className="title">
                            {<div className="dangerous-html" dangerouslySetInnerHTML={{ __html: menuItem.text }} />}
                        </div>
                        <div className="time">{menuItem.dateString}</div>
                    </div>
                    <div>
                        <Dropdown icon="ellipsis vertical">
                            <Dropdown.Menu className="left">
                                <Dropdown.Item
                                    onClick={() => {
                                        setEditMode(true);
                                    }}
                                >
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => {
                                        setDeleteMenuItem(true);
                                    }}
                                >
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>{' '}
                </>
            ) : (
                <>
                    <MenuItemForm
                        menuItem={menuItem}
                        saveHandler={updateMenu}
                        cancelHandler={() => {
                            setEditMode(false);
                        }}
                    />
                </>
            )}
        </div>
    );
};
export default MenuItem;
